exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.emapm-upload-imgs[data-v-a912844a] {\r\n    padding-bottom: 0px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-a912844a&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/emapm-form/emapComponents/emUploadImage.vue
// module id = 178
// module chunks = 0